/**
 * What to tell someone about the copy of the app on their screen.
 *
 * `clientBuild` is baked into the bundle. `serverBuild` is the same id from
 * `/health`, so they differ when a deploy is live and this screen is still
 * the previous service worker. `updateReady` is that worker waiting to take
 * over. `release` is Fly's version number, which is what a person can say
 * out loud.
 */
export function versionState(input: {
  clientBuild: string
  serverBuild: string | null
  release: string | null
  updateReady: boolean
}): {
  stale: boolean
  /** This screen is the release that is live. */
  current: string | null
  /** This screen is behind that release. */
  behind: string | null
  /** The bar. Names the release they will get. */
  ready: string | null
} {
  const stale =
    input.updateReady ||
    Boolean(input.clientBuild && input.serverBuild && input.clientBuild !== input.serverBuild)
  const named = input.release ? `version ${input.release}` : null
  return {
    stale,
    current: !stale && named ? `Version ${input.release}` : null,
    behind: stale && named ? `Older than ${named}` : stale ? 'Older than the current version' : null,
    ready: stale && named ? `Version ${input.release} is ready` : stale ? 'A new version is ready' : null,
  }
}

/** Inlined at image build. Empty in development and in the test runner. */
export const CLIENT_BUILD = import.meta.env.VITE_APP_BUILD ?? ''
